import React from 'react';
import { createTemplate } from '@/helpers/createTemplate';
import template from './templates/template';
import { usePathStartsWith } from '@/hooks/usePathStartsWith';

export default function Maintenance() {
  const isMaintenance: boolean = usePathStartsWith('/maintenance');
  return <>{createTemplate(template(isMaintenance))}</>;
}
